// extracted by mini-css-extract-plugin
export default {"SampleCloseForm":"SampleCloseForm_SampleCloseForm__TbXp9"};